// extracted by mini-css-extract-plugin
export default {"expandIcon":"xxqof9AHHuwJde7BwN9H","panel":"ZPv2yW_ojnitcUFXPBci"};